/*eslint-disable*/
import React, { useState, useEffect } from 'react'
import Axios from 'axios';
import APP_CONSTANTS from '../../config/constants';
import AgGridTableWithLoader from '../../components/agGridComponent/agGridTableWithLoader';

function ConsolidatedFuelMileage(props) {
  const [vehicleData, setVehicleData] = useState([])
  const [isLoading, setIsLoading] = useState(false)

  const searchVehicleData = (startDate, endDate) => {
    setIsLoading(true)
    const token = localStorage.getItem('apiToken')
    const data = {
      "customerNo": localStorage.getItem('customerNo'),
      "userId": localStorage.getItem('userId'),
      "startDate": startDate,
      "endDate": endDate
    }

    Axios.post(`${APP_CONSTANTS.BASE_URL}fleet/report/getConsolidatedFuelMileageReport`, data, {
      headers: {
        'Accept': 'application/json',
        "Authorization": token,
        'Content-Type': 'application/json'
      }
    })
      .then((response => {
        setVehicleData(response.data)
        setIsLoading(false)
      }))
      .catch(error => { console.log(error); setIsLoading(false); })
  }

  let columnDefs = [
    { headerName: 'Vehicle No', field: 'vehicleNo', tooltipField: 'vehicleNo', enableRowGroup: true, enablePivot: true, filter: true },
    { headerName: 'Odometer Reading', field: 'odometerReading', tooltipField: 'odometerReading', enableRowGroup: true, enablePivot: true, filter: true },
    { headerName: 'Current Odometer Reading', field: 'latestMeterReading', tooltipField: 'latestMeterReading', enableRowGroup: true, enablePivot: true, filter: true },
    { headerName: 'Total Fuel Consumption', field: 'totalFuelConsumption', tooltipField: 'totalFuelConsumption', enableRowGroup: true, enablePivot: true, filter: true },
    { headerName: 'Average Fuel Rate', field: 'averageFuelPerLtr', tooltipField: 'averageFuelPerLtr', enableRowGroup: true, enablePivot: true, filter: true },
    { headerName: 'Total Amount', field: 'totalAmount', tooltipField: 'totalAmount', enableRowGroup: true, enablePivot: true, filter: true },
    { headerName: 'Total Km Run', field: 'totalKms', tooltipField: 'totalKms', enableRowGroup: true, enablePivot: true, filter: true },
    { headerName: 'Total Kms Average', field: 'totalKmsAverage', tooltipField: 'totalKmsAverage', enableRowGroup: true, enablePivot: true, filter: true },
  ]
  let rowData = []

  vehicleData.map((object, i) => {
    let temp = {}
    temp.vehicleNo = object.vehicleNo
    temp.odometerReading = object.odometerReading
    temp.latestMeterReading = object.latestMeterReading
    temp.totalFuelConsumption = object.totalFuelConsumption
    temp.averageFuelPerLtr = object.averageFuelPerLtr
    temp.totalAmount = object.totalAmount
    temp.totalKms = object.totalKms    
    temp.totalKmsAverage = object.totalKmsAverage
    rowData[i] = temp
  })

  return (
    <React.Fragment>
      <AgGridTableWithLoader
        columnDefs={columnDefs}
        rowData={rowData}
        searchValue={props.searchValue}
        callSearch={true}
        loading={true}
        link="#"
        showCTATitle={false}
        hiddenNew={true}
        newPopup={props.newPopup}
        isLoading={isLoading}
        searchData={searchVehicleData}
        titleBarTitle="Consolidated Fuel Mileage"
        handleSearch={props.handleSearch}
      />
    </React.Fragment>
  )
}

export default ConsolidatedFuelMileage
